import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {getDisableArrowKeys} from '~/selectors/CanvasSelectors';
import Keys from '~/constants/Keyboard';
import {targetIsInput} from '~/utils/keyboard';
import useEvent from '@react-hook/event';

const DEFAULT_MULTIPLIER = 10;

export default function MoveWithKeys(props) {
  const shouldIgnoreInput = useSelector(getDisableArrowKeys);
  const handleKeyUp = useCallback(
    event => {
      const onMoveKeyUp = props?.onMoveKeyUp || (() => {});

      const {key} = event;
      const recognizedKeys = [
        Keys.ARROW.DOWN,
        Keys.ARROW.UP,
        Keys.ARROW.LEFT,
        Keys.ARROW.RIGHT,
        Keys.COMMAND
      ];

      if (recognizedKeys.includes(key) && !shouldIgnoreInput) {
        onMoveKeyUp(event);
      }
    },
    [props?.onMoveKeyUp, shouldIgnoreInput]
  );

  const handleKeyDown = useCallback(
    event => {
      if (shouldIgnoreInput) {
        return;
      }
      const multiplier = props?.multiplier || DEFAULT_MULTIPLIER;
      const onMoveKeyDown = props?.onMoveKeyDown || (() => {});

      const getMoveVector = (key, multiply) => {
        const keyToVectorMap = {
          [Keys.ARROW.DOWN]: {deltaX: 0, deltaY: 1},
          [Keys.ARROW.UP]: {deltaX: 0, deltaY: -1},
          [Keys.ARROW.LEFT]: {deltaX: -1, deltaY: 0},
          [Keys.ARROW.RIGHT]: {deltaX: 1, deltaY: 0}
        };

        const vector = keyToVectorMap[key];

        if (vector) {
          if (multiply) {
            vector.deltaX *= multiplier;
            vector.deltaY *= multiplier;
          }

          return vector;
        }
      };

      const {key, shiftKey} = event;
      const vector = getMoveVector(key, shiftKey);

      if (vector && !targetIsInput(event)) {
        onMoveKeyDown(vector, event);

        event.preventDefault();
      }
    },
    [props?.multiplier, props?.onMoveKeyDown, shouldIgnoreInput]
  );

  useEvent(window, 'keyup', handleKeyUp);
  useEvent(window, 'keydown', handleKeyDown);

  return props?.children ? props.children : null;
}
